import axios from "axios"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import {useLang} from "../components/LangProvider";

function Document({content}){

  const id = useParams().path
  const [doc, setDoc] = useState(<div className="loading">Loading something ...</div>)
  const [title, setTiltle] = useState(<></>)
  const {lang, t} = useLang()

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_BACKEND_DOCUMENTS + "/" + id,{
        headers:{
          accept:"application/json"
        },
        params:{
          with_text:1
        }
      })
      .then(
        res=>{
          //console.log('doc used', res.data[lang["lang"]],lang["lang"])
          // old API: per-language objects, new API: text_block with multilang tags
          const data = res.data[lang["lang"]] ?? res.data.text_block ?? res.data
          setDoc(t(data.text))
          setTiltle(t(data.name) || res.data.name)
        }
      )
      .catch((err) => {
        console.log("doc err",err)
      })
  },[lang])

  console.log('document content',content)
  // get doc by its path

  return <section className="document">
    <h1 className="document__header">{title}</h1>
    <article className="document__text" dangerouslySetInnerHTML={{__html:doc}}/>
  </section>
}

export default Document